<template>
  <div>
    <div v-loading="loading">
      <el-collapse v-model="activeNames">
        <div
          v-for="item in storeRegions"
          :key="item.amazonStoreRegion"
          class="mb-1"
        >
          <el-collapse-item :name="item.amazonStoreRegion">
            <template slot="title">
              <div
                style="width: 100%;display: flex;align-items: center;justify-content: space-between;"
              >
                {{ item.v_amazonStoreRegion }}
                <div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="添加行"
                    placement="top"
                  >
                    <i
                      class="el-icon-circle-plus-outline tool-btn mr-2"
                      v-if="!disabled"
                      @click.stop="onAddRow(item.amazonStoreRegion)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="清空列表数据"
                    placement="top"
                  >
                    <i
                      class="el-icon-circle-close tool-btn mr-2"
                      v-if="!disabled"
                      @click.stop="onClearTable(item.amazonStoreRegion)"
                    ></i>
                  </el-tooltip>
                </div>
              </div>
            </template>
            <PredictTable
              ref="predictTableRef"
              class="mt-1"
              :amzReplenishmentCode="amzReplenishmentCode"
              :amazonStoreRegion="item.amazonStoreRegion"
              :disabled="disabled"
              highlightCurrentRow
            />
          </el-collapse-item>
        </div>
      </el-collapse>
      <div
        v-if="isEmpty"
        style="display: flex;align-items: center;justify-content: center;height: 400px;"
      >
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import PredictTable from './predict-table'
export default {
  mixins: [EditLoading],
  components: { PredictTable },
  props: {
    disabled: { type: Boolean, default: false },
    amzReplenishmentCode: { type: String, default: '' },
  },
  data() {
    return {
      regionFormData: {
        amazonStoreRegion: '',
      },
      activeNames: [],
      storeRegions: [],
      loading: false,
    }
  },
  computed: {
    isEmpty() {
      return !this.storeRegions || this.storeRegions.length < 1
    },
  },
  async mounted() {
    await this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.getStoreRegion()
      this.loading = false
    },
    async getStoreRegion() {
      if (!this.amzReplenishmentCode) return
      const res = await this.$api
        .ecomAmzReplenishmentPromotionStoreRegionApi({
          amzReplenishmentCode: this.amzReplenishmentCode,
        })
        .catch(() => null)
      this.storeRegions = res?.body.data || []
      this.activeNames = this.storeRegions.map((e) => e.amazonStoreRegion)
    },
    async onAddRow(amazonStoreRegion) {
      const confirm = await this.$confirm(
        this.$l('tips_add_row') || '是否要添加一行记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzReplenishmentPromotionSaveApi({
          amzReplenishmentCode: this.amzReplenishmentCode,
          amazonStoreRegion,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message.success(this.$l('INDEX.tips_save_ok') || '保存成功')
      await this.$refs.predictTableRef[0].getData()
    },
    async onClearTable(amazonStoreRegion) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_clear_data') || '是否要清空数据？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api.ecomAmzReplenishmentPromotionClearAllApi({
        amzReplenishmentCode: this.amzReplenishmentCode,
        amazonStoreRegion,
      })
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_clear_success') || '清空成功！',
        type: 'success',
      })
      await this.$refs.predictTableRef[0].getData()
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-body--row {
    .vxe-body--column:first-child {
      background-color: #f8f8f9 !important;
    }
  }
  .el-collapse {
    border-top: none !important;
    border-bottom: none !important;
  }
  .el-collapse-item__header {
    font-size: 15px;
    font-weight: 600;
    height: 40px !important;
    line-height: 40px !important;
  }
}

.bg-white {
  background-color: white !important;
}
</style>
